import EcoSectionCard from 'eco-design/sections/eco-section-card';
import { useCallback } from 'react';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA8');
    const { locale } = getLocal();

    const bannerMap = {
        eu: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748141895867/a8_bg_h5.jpg',
        },
        uk: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748141895867/a8_bg_h5.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748141895867/a8_bg_h5.jpg',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748141895867/a8_bg_h5.jpg',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748141895867/a8_bg_h5.jpg',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1748141890044/a8_bg.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1748141895867/a8_bg_h5.jpg',
        },
    };

    const bannerImage = bannerMap[locale as keyof typeof bannerMap];

    const handleGtm = useCallback(
        (btnName: string) => {
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'jump_button',
                    position: `${t('title')}_${btnName}`,
                    button_name: btnName,
                    url: `${window.location.origin}/${locale}/stream-series-plug-in-solar-battery`,
                });
            } catch (e) {
                console.log(e);
            }
            const url =
                locale === 'us'
                    ? `${window.location.origin}/us/stream-ultra-home-solar-system`
                    : `${window.location.origin}/${locale}/stream-series-plug-in-solar-battery`;
            window.open(url, '_blank'); // 新窗口打开链接，防止刷新页面
        },
        [locale, t],
    );

    return (
        <div className={styles.comp}>
            <EcoSectionCard
                layout="center-left"
                theme="white"
                title={t('title')}
                desc={t('desc')}
                lRadius="ellipse"
                lChildren={
                    <div
                        onClick={() => {
                            handleGtm(t('btn1'));
                        }}
                    >
                        {t('btn1')}
                    </div>
                }
                titleColor="#fff"
                descColor="#fff"
                pc={bannerImage.pc}
                pad={bannerImage.pad}
                h5={bannerImage.h5}
            />
        </div>
    );
}
